'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _account = require('redux/modules/account');

var accountActions = _interopRequireWildcard(_account);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _EditableField = require('components/EditableField/EditableField');

var _EditableField2 = _interopRequireDefault(_EditableField);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./AccountName.scss');

var nameMaxLength = 30;

var AccountName = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    account: state.account.accountData,
    updateAccountActionData: state.account.updateAccountActionData,
    updateAccountLoading: state.account.updateAccountLoading
  };
}, (0, _extends3.default)({}, accountActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(AccountName, _Component);

  function AccountName() {
    (0, _classCallCheck3.default)(this, AccountName);
    return (0, _possibleConstructorReturn3.default)(this, (AccountName.__proto__ || (0, _getPrototypeOf2.default)(AccountName)).apply(this, arguments));
  }

  (0, _createClass3.default)(AccountName, [{
    key: 'saveName',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(value) {
        var _props, updateAccount, fieldName;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, updateAccount = _props.updateAccount, fieldName = _props.fieldName;
                _context.next = 3;
                return updateAccount((0, _defineProperty3.default)({}, fieldName, value)).promise;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function saveName(_x) {
        return _ref.apply(this, arguments);
      }

      return saveName;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          account = _props2.account,
          updateAccountLoading = _props2.updateAccountLoading,
          updateAccountActionData = _props2.updateAccountActionData,
          className = _props2.className,
          textClass = _props2.textClass,
          fieldName = _props2.fieldName;

      var loading = updateAccountLoading && !!updateAccountActionData[fieldName];

      return _react2.default.createElement(_EditableField2.default, {
        className: className,
        textClass: textClass,
        onSave: this.saveName,
        value: account[fieldName],
        loading: loading,
        inputProps: { maxLength: nameMaxLength },
        inputClass: styles.nameInput,
        containerClass: styles.nameInputContainer,
        saveOnBlur: false,
        type: 'text'
      });
    }
  }]);
  return AccountName;
}(_react.Component), _class3.propTypes = {
  account: _propTypes2.default.object,
  className: _propTypes2.default.string,
  fieldName: _propTypes2.default.string.isRequired,
  textClass: _propTypes2.default.string,
  updateAccount: _propTypes2.default.func,
  updateAccountActionData: _propTypes2.default.object,
  updateAccountLoading: _propTypes2.default.bool
}, _class3.defaultProps = {
  account: {},
  updateAccountActionData: {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'saveName', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'saveName'), _class2.prototype)), _class2)) || _class);
exports.default = AccountName;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Account/AccountName/AccountName.js
// module id = 2141
// module chunks = 1